import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { User } from '@inboundhost/shared';
import { api, clearToken, setToken } from '../lib/api';

interface AuthResponse {
  user: User;
  token: string;
  siteId: string;
}

export function useCurrentUser() {
  return useQuery({
    queryKey: ['me'],
    queryFn: () => api<{ user: User }>('/auth/me'),
    retry: false,
  });
}

export function useLogin() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: { email: string; password: string }) =>
      api<AuthResponse>('/auth/login', { method: 'POST', body: JSON.stringify(input) }),
    onSuccess: (res) => {
      setToken(res.token);
      qc.setQueryData(['me'], { user: res.user });
    },
  });
}

export function useSignup() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: {
      email: string;
      password: string;
      businessName: string;
      businessType: string;
      subdomain: string;
    }) => api<AuthResponse>('/auth/signup', { method: 'POST', body: JSON.stringify(input) }),
    onSuccess: (res) => {
      setToken(res.token);
      qc.setQueryData(['me'], { user: res.user });
    },
  });
}

export function useLogout() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => api<{ ok: true }>('/auth/logout', { method: 'POST' }),
    onSuccess: () => {
      clearToken();
      qc.clear();
    },
  });
}
